import { useEffect, useState } from 'react';
import type { AppToolLink } from '@shared/app-tool-links';
import { loadAppToolLinks } from '@/lib/app-tool-links';

/** S1: the tools proposed on the objects of an app (none while loading or when it fails). */
export const useAppToolLinks = (appId: string): { links: AppToolLink[]; error: string | null } => {
  const [state, setState] = useState<{ appId: string; links: AppToolLink[]; error: string | null } | null>(null);
  useEffect(() => {
    let active = true;
    void loadAppToolLinks(appId)
      .then((links) => { if (active) setState({ appId, links, error: null }); })
      .catch((cause) => { if (active) setState({ appId, links: [], error: cause instanceof Error ? cause.message : 'Outils non chargés.' }); });
    return () => { active = false; };
  }, [appId]);
  return state?.appId === appId ? { links: state.links, error: state.error } : { links: [], error: null };
};
